import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import {
	Accordion,
	Button,
	Card,
	Col,
	Container,
	Form,
	FormCheck,
	FormControl,
	Row,
} from 'react-bootstrap';
import ChangePassword from './../components/ChangePassword';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faPencilSquare } from '@fortawesome/free-solid-svg-icons';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import PhoneInput from '../components/formComponents/PhoneInput';
import CustomStatesDropdown from '../components/formComponents/CustomStatesDropdown/CustomStatesDropdown';
import AutoSaveInput from '../components/formComponents/AutoSaveInput/AutoSaveInput';
import { PHP } from '../utils/axiosConfig';

const Profile = () => {
	const php = PHP();
	const { user, login } = useAuth();
	const [phone, setPhone] = useState();

	const [form, setForm] = useState({
		address: '',
		city: '',
		state: '',
		zipcode: '',
	});
	const [isEditing, setIsEditing] = useState(false);

	useEffect(() => {
		if (user) {
			setForm({
				id: user.id,
				email: user.email,
				address: user.address,
				city: user.city,
				state: user.state,
				zipcode: user.zipcode,
			});
			setPhone(user.phone);
		}
	}, [user]);

	const handleForm = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const saveProfileForm = () => {
		let formData = new FormData();
		formData.append('id', form.id);
		formData.append('email', form.email);
		formData.append('address', form.address);
		formData.append('city', form.city);
		formData.append('state', form.state);
		formData.append('zipcode', form.zipcode);
		formData.append('phone', phone);
		formData.append('route', 'update_profile');

		php
			.post('user.php', formData)
			.then((res) => {
				console.log(res);
				if (res.status == 200) {
					login(res.data.user);
					setIsEditing(false);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	};

	return (
		<div id="profile" className="page">
			<Container className="pt-4 pb-4">
				{user && (
					<Card className="shadow-card">
						<Card.Header>
							<h4>Client Profile</h4>
						</Card.Header>
						<Card.Body>
							<Form>
								<Form.Group className="float-end">
									<Form.Label className="me-2">Edit:</Form.Label>
									<FormCheck
										inline
										type="switch"
										name="editing"
										value={isEditing}
										onClick={() => setIsEditing(!isEditing)}
									/>
								</Form.Group>
								<div>
									{user.firstName} {user.lastName}
								</div>
								<hr />
								<div>
									<Form.Label>Email:</Form.Label>{' '}
									<FormControl
										type="text"
										name="email"
										onChange={handleForm}
										placeholder="Email"
										value={user.email}
										disabled={!isEditing}
									/>
								</div>
								<div className="profile-input">
									<PhoneInput
										phone={phone ?? ''}
										setPhone={setPhone}
										disabled={!isEditing}
									/>
								</div>
								<div>
									<Form.Label>Address:</Form.Label>
									{/* <AutoSaveInput saveFunction={saveProfileValue}> */}
									<FormControl
										type="text"
										name="address"
										value={form.address}
										onChange={handleForm}
										placeholder="Address"
										disabled={!isEditing}
									/>
									{/* </AutoSaveInput> */}
								</div>
								<Row>
									<Col sm={{ span: 4 }}>
										<Form.Label>City:</Form.Label>
										<FormControl
											type="text"
											name="city"
											value={form.city}
											onChange={handleForm}
											placeholder="City"
											disabled={!isEditing}
										/>
									</Col>
									<Col sm={{ span: 4 }}>
										<Form.Label>State:</Form.Label>
										<CustomStatesDropdown
											state={form.state}
											setState={(value) => setForm({ ...form, state: value })}
											disabled={!isEditing}
										/>
									</Col>
									<Col sm={{ span: 4 }}>
										<Form.Label>Zip Code:</Form.Label>
										<FormControl
											type="text"
											name="zipcode"
											value={form.zipcode}
											onChange={handleForm}
											disabled={!isEditing}
										/>
									</Col>
								</Row>
								{isEditing && (
									<Row>
										<Col className="d-flex justify-content-end">
											<Button
												className="mt-4"
												type="button"
												onClick={saveProfileForm}
												style={{ width: '100px' }}
											>
												Save
											</Button>
										</Col>
									</Row>
								)}
							</Form>
							<hr />
							<Row>
								<Col md={{ span: 4 }}>
									<Accordion>
										<Accordion.Item eventKey="0">
											<Accordion.Header>
												<FontAwesomeIcon
													className="me-2"
													icon={faKey}
													style={{ color: 'gold' }}
												/>
												Change Password
											</Accordion.Header>
											<Accordion.Body>
												<ChangePassword />
											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								</Col>
							</Row>
						</Card.Body>
					</Card>
				)}
			</Container>
		</div>
	);
};
export default Profile;
